import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  Divider,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { getQuoteText } from '@utils/representativeQuotes';

export const ThemesData = ({ results }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        mt: 3,
        borderRadius: 3,

        transition: 'all 0.3s ease',
      }}
    >
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
          Thematic Insights
        </Typography>

        <Divider sx={{ mb: 2 }} />

        {results.themes?.map((themeObj, index) => (
          <Accordion key={index} variant="outlined" sx={{ mb: 1 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ '& .MuiAccordionSummary-content': { alignItems: 'center', gap: 2 } }}
            >
              <Typography variant="subtitle2">{themeObj.theme}</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary', lineHeight: 1.7 }}>
                {themeObj.summary}
              </Typography>

              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Representative Quotes
              </Typography>

              <Stack spacing={1.5}>
                {themeObj.representative_quotes.map((quote, qIndex) => (
                  <Paper
                    key={qIndex}
                    variant="outlined"
                    sx={{
                      p: 1.5,
                      bgcolor: 'grey.50',
                      borderRadius: 2,
                      fontStyle: 'italic',
                      color: 'text.secondary',
                    }}
                  >
                    “{getQuoteText(quote)}”
                  </Paper>
                ))}
              </Stack>
            </AccordionDetails>
          </Accordion>
        ))}
      </CardContent>
    </Card>
  );
};
